import { isA11yCheckVersion, getElementIdx } from "../functions/a11y.ui";
import UI from "./base/UI";
/**
 * Sortable
 */

 /**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_list.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_list.html)
*   *ui-sortable => 버튼형 순서변경(접근성용),  jui-sortable => 드래그형 순서변경(simple.ui.js : frontUI.editHomeDrag())
*/
class Sortable extends UI {
    defaults = {
    };

    a11yObj = {
        type: null,
        beforeNum: null,
        curNum: null,
    }

    constructor(el, options) {
        super('sortable', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        this.render();

        if(isA11yCheckVersion()){
            this.isA11yCreateArea();
        }
    }
    
    update(_this, type) {
        let  buttonLen
        if (_this != undefined) { // 클릭한 시점 
            buttonLen = _this.closest('.ui-sortable').find('[sortable-button-down]').length;
            _this.closest('.ui-sortable').find('[sortable-button-down]').each(function(idx,el){
                if (idx == buttonLen-1) {
                    $(el).attr('disabled','disabled');
                } else {
                    $(el).removeAttr('disabled');
                }
            })
            _this.closest('.ui-sortable').find('[sortable-button-up]').each(function(idx,el){
                if (idx == 0) {
                    $(el).attr('disabled','disabled');
                } else {
                    $(el).removeAttr('disabled');
                }
            })
            if (_this.attr('disabled') == 'disabled') {

                if(isA11yCheckVersion()){
                    if(this.a11yObj.type === 'up'){
                        _this.next().focus();
                    }else if(this.a11yObj.type === 'down'){
                        _this.prev().focus();
                    }
                }else{
                    //기존
                    _this.next().focus();
                }
            } else {
                _this.focus();
            }
            if ($(_this).closest('.ui-sortable').data('ui').callback && $.isFunction($(_this).closest('.ui-sortable').data('ui').callback)) {
                var listItem = $(_this).closest('.ui-sortable').find('[sortable-item]').map(function(){
                    return $(this).attr('data-id')
                }).get()
                $(_this).closest('.ui-sortable').data('ui').callback(
                    $(_this).closest('.ui-sortable').data('ui').el,
                    $(_this).closest('.ui-sortable').attr('id'),
                    $(_this).closest('[sortable-item]').attr('data-id'),
                    listItem
                );
            }
        } else { // 처음 세팅 
            buttonLen = this.$el.find('[sortable-button-down]').length;
            this.$el.find('[sortable-button-down]').each(function(idx,el){
                if (idx == buttonLen-1) {
                    $(el).attr('disabled','disabled');
                } else {
                    $(el).removeAttr('disabled');
                }
            })
            this.$el.find('[sortable-button-up]').each(function(idx,el){
                if (idx == 0) {
                    $(el).attr('disabled','disabled');
                } else {
                    $(el).removeAttr('disabled');
                }
            })
        }
        
        // if (this.$el.hasClass('type-hide')) {
        //     this.$el.find('[sortable-button-down]').each(function(idx,el){
        //         $(el).attr('disabled','disabled');
        //     })
        //     this.$el.find('[sortable-button-up]').each(function(idx,el){
        //         $(el).attr('disabled','disabled');
        //     })
        // }

        /*! s: FETASK-a11y isA11yMakeSortableObj v.1.0.0 */
        // if (type != 'showhide') {
            
        // }
        if(isA11yCheckVersion()){
            this.isA11yMakeSortableLiveText(_this);
        }
        
        /*! e: FETASK-a11y isA11yMakeSortableObj v.1.0.0 */
    }
    /**
     * 비동기적으로 실행시 render()  | 일반적으로 버튼형 순서변경가 접근성용 순서변경으로 선택시 나오는 유형이라 render가 필요  
     * @example 
     * $('.ui-sortable').data('ui').render();
     */
    render() {
        this.update();
        this.detachEvents();
        this.attachEvents();

    }

    attachEvents() {
        const that = this;
        
        this.indexSet(this.$el.find('[sortable-item]'))
        $('[sortable-button-down]').off('click.sortBtnDown').on('click.sortBtnDown', function(){
            const $thisItem = $(this).closest('[sortable-item]');
            const $nextItem = $(this).closest('[sortable-item]').next()

            if(isA11yCheckVersion()){
                that.a11yObj.type = 'down';
            }
            $nextItem.after($thisItem)
            that.update($(this))
            that.indexSet($(this).closest('.ui-sortable').find('[sortable-item]'))
            
        })
        $('[sortable-button-up]').off('click.sortBtnUp').on('click.sortBtnUp', function(){
            const $thisItem = $(this).closest('[sortable-item]');
            const $prevItem = $(this).closest('[sortable-item]').prev()
            if(isA11yCheckVersion()){
                that.a11yObj.type = 'up';
            }
            $prevItem.before($thisItem)
            that.update($(this))
            that.indexSet($(this).closest('.ui-sortable').find('[sortable-item]'))
        })
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }
    /**
     * 변경시 콜백 
     * 
     * @param callback    {Function}  메세지값
     * @example 
     * $('.ui-sortable').data('ui').sortableCallback(function(){});
     * @typeof {Object} returns
     * @property {element} a -this
     * @property {string} b - this.id
     * @property {string} c - activeItem.dataId
     * @property {string[]} d - listItem
     * @returns {returns} a,b,c,d
     */
    sortableCallback(callback) {
        console.log($.isFunction(callback))
        this.callback = callback
    }
    destroy() {
        this.detachEvents();
    }

    isA11yCreateArea(){
        try {
            const newSortArea = document.createElement('div');
            newSortArea.setAttribute('aria-live','polite');
            newSortArea.setAttribute('aria-atomic','false');
            newSortArea.setAttribute('aria-relevant','additions text');
            newSortArea.setAttribute('style', 'position:absolute;top:-99999px;left:-99999px;opacity:0;');
            newSortArea.classList.add('sort-live');

            $('.sort-live').remove();

            document.querySelector('body').after(newSortArea);   
        } catch (error) {
            throw new Error(error);
        }
    }

    isA11yMakeSortableLiveText(_this){
        try {
            //if(!this.a11yObj.type && !this.a11yObj.beforeNum && !this.a11yObj.curNum) return;
            if(!this.a11yObj.type) return;
            let listItem;
            if (_this != undefined) {
                listItem = _this.closest('.ui-sortable').find('[sortable-item]');
            } else {
                listItem = this.$el.find('[sortable-item]');
            }
            //let listItem = this.$el[0]?.querySelectorAll('[sortable-item]');
            
            let currentIndex = Number(_this.closest('[sortable-item]').attr('sortable-item-index'))
            if(listItem?.length){
                const liveDiv = document.createElement('div');
                liveDiv.classList.add('sort-item-text');
                const sortAreaEle = document.querySelector('.sort-live');
    
                //const curItem = listItem[this.a11yObj.curNum]; //현재 이동되는 기준 list
                const titText = _this.closest('[sortable-item]')[0]?.querySelector('.tit-list')?.innerText ?? '';
                const titTxt = _this.closest('[sortable-item]')[0]?.querySelector('.list-row-name')?.innerText ?? '';
                const boxStateText = _this.closest('[sortable-item]')[0]?.querySelector('.box-state')?.innerText ?? '';
                let readLiveText = '';
                let prevIndex = 0 ;
                let nextIndex = 0 ;
                if (this.a11yObj.type == 'down') {
                    prevIndex = currentIndex;
                    nextIndex = currentIndex + 1;
                } else if (this.a11yObj.type == 'up') {
                    prevIndex = currentIndex;
                    nextIndex = currentIndex - 1;
                }
                readLiveText = `${titText} ${titTxt} ${boxStateText} ${prevIndex}번째에서 ${nextIndex}번째로 이동 되었습니다.`;
            
                liveDiv.textContent = readLiveText;
    
                sortAreaEle.append(liveDiv);
                console.log(liveDiv)
                setTimeout(() => {
                    liveDiv.remove();
                }, 100 * readLiveText?.length);


                this.indexSet(_this.closest('.ui-sortable').find('[sortable-item]'))
            }
        }catch(error){
            throw new Error(error);
        }
    }

    indexSet(item) {
        item.each(function(i,e){
            $(e).attr('sortable-item-index', i+1)
        })
    }
}

export default Sortable;
